import { Component } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IgxButtonDirective, IgxDialogModule } from '@infragistics/igniteui-angular'
import { environment } from '../../../environments/environment'
import { LinkIconComponent, LinkIconModel } from '../../components/link-icon/link-icon.component'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'app-welcome',
  imports: [CommonModule, IgxDialogModule, LinkIconComponent],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss',
})
export class WelcomeComponent {
  environmentCd = environment.environmentCd
  icons: LinkIconModel[] = [
    {
      id: '0',
      name: '会員向けサービス',
      type: 'url',
      url: environment.ui.dashboardUIUrl,
      icon: '../../../assets/img/auto_awesome_24dp.png',
      petaboParam: '',
    },
    {
      id: '1',
      name: 'アカウント登録',
      type: 'account',
      url: '',
      icon: '../../../assets/img/how_to_reg_24dp.png',
      petaboParam: '',
    },
  ]
  constructor(private router: Router, private activeRoute: ActivatedRoute) {}

  // 初期化
  ngOnInit(): void {}
  clickMenu(item: any) {
    switch (item.type) {
      case 'account':
        this.router.navigate(['register-account'])
        break
    }
  }
}
